import { motion } from 'framer-motion'
import { track } from '../lib/track'

const MONO = "'JetBrains Mono', 'Fira Code', Consolas, Monaco, monospace"

export default function ContactCTA() {
  return (
    <section style={{
      borderTop: '1px solid var(--border)',
      padding: '4rem 1.5rem 5rem',
    }}>
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        style={{ maxWidth: 1100, margin: '0 auto' }}
      >
        <div style={{
          fontFamily: MONO,
          fontSize: '0.68rem',
          color: 'var(--muted2)',
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          marginBottom: '1.25rem',
        }}>
          contato
        </div>

        <p style={{
          fontFamily: "'Inter', system-ui, sans-serif",
          fontWeight: 600,
          fontSize: 'clamp(1.3rem, 2.8vw, 1.9rem)',
          lineHeight: 1.2,
          color: 'var(--text)',
          letterSpacing: '-0.025em',
          maxWidth: 520,
          marginBottom: '2.5rem',
        }}>
          Quer um sistema de receita que de fato funciona?
        </p>

        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          <a
            href="mailto:linharesmatheus29@gmail.com"
            onClick={() => track('cta_click', { location: 'contact_section', type: 'email' })}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              fontSize: '0.85rem',
              fontWeight: 500,
              fontFamily: MONO,
              color: 'var(--text)',
              padding: '0.7rem 1.2rem',
              border: '1px solid var(--border-strong)',
              borderRadius: 6,
              transition: 'border-color 0.15s, background 0.15s',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor = 'var(--text)'
              e.currentTarget.style.background = 'var(--bg2)'
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor = 'var(--border-strong)'
              e.currentTarget.style.background = 'transparent'
            }}
          >
            linharesmatheus29@gmail.com
          </a>

          <div style={{ display: 'flex', gap: '1.25rem', alignItems: 'center' }}>
            <a
              href="https://www.linkedin.com/in/matheus-edson-linhares-4620b82b1/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: '0.82rem', color: 'var(--muted)', fontFamily: MONO, transition: 'color 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--text)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--muted)'}
            >
              LinkedIn
            </a>
            <a
              href="https://github.com/MatheusEdson"
              target="_blank"
              rel="noopener noreferrer"
              style={{ fontSize: '0.82rem', color: 'var(--muted)', fontFamily: MONO, transition: 'color 0.15s' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--text)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--muted)'}
            >
              GitHub
            </a>
          </div>
        </div>

        <div style={{
          marginTop: '3rem',
          fontFamily: MONO,
          fontSize: '0.75rem',
          color: 'var(--muted2)',
        }}>
          matheus edson · GTM Engineer · Uberlândia, MG
        </div>
      </motion.div>
    </section>
  )
}
